<script>
import newBidInput from "../components/form components/newBidInput";

export default {
  name: "multi-vessel-offer",
  components: {
    newBidInput,
  },
  data: function() {
    return {
      data: [],
    };
  },
  methods: {
    onModalClose: function() {
      this.$store.commit("setMultiVesselDealVisible", false);
    },
    async makeMultiVesselOffer() {
      var self = this;
      await this.$store.dispatch("postRequest", { controller: "auction", method: `MultiVesselOffer/${self.auctionId}`, parameters: self.formatOffersForSubmission() });
      this.onModalClose();
    },
    formatOffersForSubmission() {
      return this.data
        .filter(function(x) {
          return x.included;
        })
        .map(function(x) {
          return { OfferId: x.id, Rate: x.rate, VesselName: x.name };
        });
    },
    resetData: function() {
      this.data = this.bids.map(function(o) {
        return { id: o.offerId, name: o.vesselName, included: true, rate: o.currentRate };
      });
    },
    addCommas: function(x) {
      if (isNaN(x)) {
        return 0;
      }
      var parts = x.toString().split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return parts.join(".");
    },
  },
  computed: {
    auctionId: function() {
      return this.$store.state.activeAuction.id;
    },
    currency: function() {
      return this.$store.state.activeAuction.currency;
    },
    content: function() {
      return this.$store.state.messageContent ? this.$store.state.messageContent : "";
    },
    title: function() {
      return this.$store.state.messageTitle ? this.$store.state.messageTitle : "";
    },
    messageType: function() {
      return this.$store.state.messageType ? this.$store.state.messageType : "";
    },
    modalVisible: function() {
      return this.$store.state.multiVesselDealVisible;
    },
    bids: function() {
      return this.$store.state.activeAuction.bids;
    },
    offerSummary: function() {
      var self = this;
      return this.data
        .filter(function(x) {
          return x.included;
        })
        .map(function(x) {
          return `${x.name} at ${self.currency} ${self.addCommas(x.rate)}`;
        })
        .join("<br/>");
    },
    canOffer: function() {
      return (
        this.data.filter(function(x) {
          return x.included;
        }).length > 1
      );
    },
  },
  mounted: function() {
    this.resetData();
  },
};
</script>
<template>
  <div>
    <b-modal id="multi-vessel-deal-modal" title="Make Package Offer" v-model="modalVisible" v-on:hidden="onModalClose" v-on:show="resetData">
      <div class="row" v-for="item in data" :key="`row-${item.id}`">
        <div class="col-4">
          <span>{{ item.name }}</span>
        </div>
        <div class="col-4">
          <new-bid-input v-model="item.rate" :inputValue="parseInt(item.rate)" :formatAsCurrency="true"></new-bid-input>
        </div>
        <div class="col-4">
          <button type="button" class="btn btn-light" v-on:click="item.included = !item.included"><span v-if="item.included">Remove</span><span v-else>Include</span></button>
        </div>
      </div>
      <div class="offer-summary" v-html="offerSummary"></div>
      <template v-slot:modal-footer="{ ok, cancel }">
        <div class="row" style="width:100%">
          <div class="col-6" style="padding-left:0px;">
            <b-button size="sm" variant="danger" block v-on:click="cancel()">
              Cancel
            </b-button>
          </div>
          <div class="col-6" style="padding-right:0px;">
            <b-button :disabled="!canOffer" size="sm" variant="success" block v-on:click="makeMultiVesselOffer()">
              Make Offer
            </b-button>
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>
